import { Fragment } from "react";

import { useHistory } from "react-router-dom";

import EditIcon from "@material-ui/icons/Edit";

import { useNewSubscriberContext } from "../../Context/NewSubsciberContext";
import { setStatusBackToSummary } from "../../Context/NewSubscriberAction";
import { Box, Typography } from "@material-ui/core";
import { SummaryCard } from "../../../transactions/newInvestor/lib/CardComponent2";

const labelText = {
  fontSize: "14px",
  fontWeight: 400,
  color: "#002856",
  lineHeight: "16px",
};

const bodyText = {
  fontSize: "14px",
  fontWeight: 400,
  color: "#000000",
  lineHeight: "16px",
};

const NomineeDetailsPreview = () => {
  // const { nomineeDetailsPreview = {} } = useSelector(
  //   (state) => state.newSubscriber.preview
  // );
  const history = useHistory();
  const { nomineeDetails, dispatch: contextDispatch } =
    useNewSubscriberContext();
  // const { data = {} } = nomineeDetailsPreview;
  const NominationList = nomineeDetails?.data?.NominationList;
  const NominationList2 = nomineeDetails?.data?.NominationsList2;
  const back = () => {
    contextDispatch(setStatusBackToSummary(true));
    history.push({
      pathname: "/nps/AddSubs/nominee-details",
    });
  };
  return (
    <Fragment>
      <div className="new-subscriber-container">
        <div
          style={{
            paddingLeft: "16px",
            fontSize: "18px",
            color: "#000000",
            fontWeight: "400",
            opacity: "0.8",
            paddingBottom: "4px",
          }}
        >
          NOMINEE DETAILS
        </div>
        <EditIcon onClick={back} className="cursor" />
      </div>
      <div>
        {NominationList?.map((_eachNominee, index) => {
          return (
            <div key={index}>
              <SummaryCard title="TIER I">
                <div
                  style={{
                    textAlign: "start",
                    margin: "20px 0px 0px 10px",
                    fontSize: "15px",
                    fontWeight: 600,
                    fontFamily: `'Roboto', sans-serif`,
                  }}
                >
                  Nominee {index + 1}
                </div>
                <Box
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr 1fr",
                    gridRowGap: "2rem",
                    padding: "20px 6px 20px 6px",
                    margin: "0px 5px 20px 10px",
                  }}
                >
                  <div>
                    <Typography style={labelText}>Name</Typography>
                    <Typography style={bodyText}>
                      {_eachNominee?.FirstName}
                    </Typography>
                  </div>
                  <div>
                    <Typography style={labelText}>Relationship</Typography>
                    <Typography style={bodyText}>
                      {_eachNominee?.RelationTypeName}
                    </Typography>
                  </div>
                  <div>
                    <Typography style={labelText}>Share</Typography>
                    <Typography style={bodyText}>
                      {_eachNominee?.Nompercentage}%
                    </Typography>
                  </div>
                  <div>
                    <Typography style={labelText}>
                      Nominee {index + 1} DOB
                    </Typography>
                    <Typography style={bodyText}>
                      {_eachNominee?.DateOfBirth}
                    </Typography>
                  </div>
                  {_eachNominee?.GuardianFirstName && (
                    <div>
                      <Typography style={labelText}>Guardian Name</Typography>
                      <Typography style={bodyText}>
                        {_eachNominee?.GuardianFirstName}
                      </Typography>
                    </div>
                  )}
                </Box>
              </SummaryCard>
            </div>
          );
        })}
      </div>
      {NominationList2 && (
        <div>
          {NominationList2?.map((_eachNominee, index) => {
            return (
              <div key={index}>
                <SummaryCard title="TIER II">
                  <div
                    style={{
                      textAlign: "start",
                      margin: "20px 0px 0px 10px",
                      fontSize: "15px",
                      fontWeight: 600,
                      fontFamily: `'Roboto', sans-serif`,
                    }}
                  >
                    Nominee {index + 1}
                  </div>
                  <Box
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr 1fr",
                      gridRowGap: "2rem",
                      padding: "20px 6px 20px 6px",
                      margin: "0px 5px 20px 10px",
                    }}
                  >
                    <div>
                      <Typography style={labelText}>Name</Typography>
                      <Typography style={bodyText}>
                        {_eachNominee?.FirstName}
                      </Typography>
                    </div>
                    <div>
                      <Typography style={labelText}>Relationship</Typography>
                      <Typography style={bodyText}>
                        {_eachNominee?.RelationTypeName}
                      </Typography>
                    </div>
                    <div>
                      <Typography style={labelText}>Share</Typography>
                      <Typography style={bodyText}>
                        {_eachNominee?.Nompercentage}%
                      </Typography>
                    </div>
                    <div>
                      <Typography style={labelText}>
                        Nominee {index + 1} DOB
                      </Typography>
                      <Typography style={bodyText}>
                        {_eachNominee?.DateOfBirth}
                      </Typography>
                    </div>

                    {_eachNominee?.GuardianFirstName && (
                      <div>
                        <Typography style={labelText}>Guardian Name</Typography>
                        <Typography style={bodyText}>
                          {_eachNominee?.GuardianFirstName}
                        </Typography>
                      </div>
                    )}
                  </Box>
                </SummaryCard>
              </div>
            );
          })}
        </div>
      )}
    </Fragment>
  );
};

export default NomineeDetailsPreview;

/* <div>
  <p>{_eachNominee.FirstName}</p>
  <p>{_eachNominee.RelationTypeName}</p>
  <p>{_eachNominee.NomineePercent}</p>
</div>; */
